/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { Chain } from '@shared/data-access/interfaces';
import { UtilityService } from '@shared/data-access/services';

@Component({
	selector: 'home-page-nav',
	templateUrl: './page-nav.component.html',
	styleUrl: './page-nav.component.scss',
	standalone: false
})
export class PageNavComponent implements OnInit {
	@Input() data: any;
	@Input() addlData: any;
	public targetService: any;
	chainAbr: string;
	public numColumns: number;
	public chunkedData: any;

	constructor(
		public utilityService: UtilityService,
		private chain: Chain
	) {
		this.chainAbr = this.chain.chainIdentifierAbbr;
	}

	ngOnInit() {
		this.targetService = this.utilityService.target;
		this.numColumns = this.determineNumColumns();
		this.chunkedData = this.buildData();
	}

	scrollToElement(link) {
		if (link.indexOf('/') > -1) {
			window.location.assign(link);
			window.location.replace(link);
		}

		link = link.replace(
			// eslint-disable-next-line no-useless-escape
			/\s|\!|\@|\#|\$|\&|\%|\^|\*|\(|\)|\{|\}|\[|\]|\;|\'|\"|\,|<|>|\.|\/|\\|\||\?|\_|\+|\=|\`|\~|\‘|\’|\“|\”|\…|\′/g,
			''
		);
		window.location.hash = '';
		window.location.hash = link;
	}

	showButton() {
		return this.chainAbr !== 'gg';
	}

	createPageNavDataTag(title) {
		title = title.replace(/\s/g, '');
		return `TopNavigation_${title}`;
	}

	chunkArray = (arr = [], size: number) =>
		arr.length > size ? [arr.slice(0, size), ...this.chunkArray(arr.slice(size), size)] : [arr];

	buildData() {
		const chunkedArray = this.chunkArray(this.data, this.numColumns);
		const lastArray = chunkedArray[chunkedArray.length - 1];
		chunkedArray[chunkedArray.length - 1] = [
			...lastArray,
			...Array(this.numColumns - lastArray.length).fill(null)
		];
		return chunkedArray;
	}

	determineNumColumns() {
		return this.data && this.data.length < 6 ? this.data.length : 6;
	}
}
